export const ERRORS_TRANSLATION_NAMESPACE = "errors";

export const NOT_FOUND_TK = "NOT_FOUND_TK";
export const TO_COME_TK = "TO_COME_TK";
export const UNDER_MAINTENANCE_TK = "UNDER_MAINTENANCE_TK";
export const ERROR_TK = "ERROR_TK";
export const NOT_ALLOWED_TK = "NOT_ALLOWED_TK";
